const toggleInList = (list, item) =>
  list.includes(item)
    ? list.filter(_item => _item !== item)
    : list.concat(item);

export default toggleInList;
